import { render } from "./HelpMessage.vue?vue&type=template&id=a3fe940a"
import script from "./HelpMessage.vue?vue&type=script&lang=js"
export * from "./HelpMessage.vue?vue&type=script&lang=js"

import "./HelpMessage.vue?vue&type=style&index=0&id=a3fe940a&lang=css"

import exportComponent from "/builds/nex/company-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__